// src/features/marketResearch/hooks/useMarketResearch.ts
import { useState, useEffect } from 'react';
import { fetchMarketResearchAPI, generateMarketResearchAPI, deleteMarketResearchAPI } from '../services/marketResearchService';
import { ExtendedMarketResearch } from '../types';

export const useMarketResearch = (hotelId?: string) => {
  const [data, setData] = useState<ExtendedMarketResearch[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!hotelId) return;
    fetchMarketResearchAPI(hotelId)
      .then(setData)
      .catch(() => setError('Failed to load data'));
  }, [hotelId]);

  // generate market research generateMarketResearch
  const generateMarketResearch = async () => {
    if (!hotelId) return;
    setLoading(true);
    setError(null);
    try {
      const newReport = await generateMarketResearchAPI(hotelId);
      setData((prev) => [newReport, ...prev]);
    } catch {
      setError('Failed to generate market research');
    } finally {
      setLoading(false);
    }
  };

  // delete market research report
  const deleteMarketResearch = async (reportId: string | number) => {
    if (!hotelId) return;
    setError(null);
    try {
      await deleteMarketResearchAPI(hotelId, reportId);
      setData((prev) => prev.filter(report => report.id !== reportId));
    } catch {
      setError('Failed to delete market research report');
    }
  };

  return { data, loading, error, generateMarketResearch, deleteMarketResearch };
};
